import styled from 'styled-components/macro'

export const AppView = styled.div`
  overflow: hidden;
`
